import { createSelector } from 'reselect';

const profileSelect = ({ profile }) => profile;

const settingsSelector = createSelector(
  profileSelect,
  ({ notificationsSettings }) => notificationsSettings,
);

export const selectNotificationsSettings = createSelector(settingsSelector, (settings) =>
  settings.get('data'),
);

export const selectNotificationsSettingsLoading = createSelector(settingsSelector, (settings) =>
  settings.get('loading'),
);

export const selectNotificationsSettingsUpdating = createSelector(settingsSelector, (settings) =>
  settings.get('updating'),
);
